import { cn } from "@choose/ui";
import { Avatar, AvatarFallback, AvatarImage } from "@choose/ui/avatar";

import type { Ticket } from "~/stores/tickets-store";

export function AssigneeAvatar({
  assignee,
  size = "default",
}: {
  assignee: Ticket["assignedTo"];
  size: "sm" | "default";
}) {
  if (!assignee) return null;

  return assignee.__typename === "ActorInternalUser" ? (
    <Avatar
      className={cn({
        "size-5": size === "default",
        "size-4": size === "sm",
      })}
    >
      <AvatarImage
        src={assignee.internalUser.picture}
        alt={`${assignee.internalUser.firstName} ${assignee.internalUser.lastName}`}
      />
      <AvatarFallback className="text-xs">
        {assignee.internalUser.firstName[0] ?? ""}
        {assignee.internalUser.lastName[0] ?? ""}
      </AvatarFallback>
    </Avatar>
  ) : assignee.__typename === "ActorBotUser" ? (
    <Avatar
      className={cn({
        "size-5": size === "default",
        "size-4": size === "sm",
      })}
    >
      <AvatarImage
        src={`https://api.dicebear.com/9.x/bottts/svg?seed=${assignee.id}`}
        alt={assignee.botUser.name}
      />
      <AvatarFallback className="text-xs">
        {assignee.botUser.name}
      </AvatarFallback>
    </Avatar>
  ) : (
    <Avatar
      className={cn({
        "size-5": size === "default",
        "size-4": size === "sm",
      })}
    >
      <AvatarImage
        src={assignee.supplierUser.picture}
        alt={`${assignee.supplierUser.firstName} ${assignee.supplierUser.lastName}`}
      />
      <AvatarFallback className="text-xs">
        {assignee.supplierUser.firstName[0] ?? ""}
        {assignee.supplierUser.lastName[0] ?? ""}
      </AvatarFallback>
    </Avatar>
  );
}

export function Assignee({ assignee }: { assignee: Ticket["assignedTo"] }) {
  if (!assignee) return null;

  return assignee.__typename === "ActorInternalUser" ? (
    <div className="flex items-center gap-2">
      <AssigneeAvatar assignee={assignee} size="sm" />
      <span className="text-sm font-medium">{`${assignee.internalUser.firstName} ${assignee.internalUser.lastName}`}</span>
    </div>
  ) : assignee.__typename === "ActorBotUser" ? (
    <div className="flex items-center gap-2">
      <AssigneeAvatar assignee={assignee} size="sm" />
      <span className="text-sm font-medium">{assignee.botUser.name}</span>
    </div>
  ) : (
    <div className="flex items-center gap-2">
      <AssigneeAvatar assignee={assignee} size="sm" />
      <span className="text-sm font-medium">{`${assignee.supplierUser.firstName} ${assignee.supplierUser.lastName}`}</span>
    </div>
  );
}
